import {Component, OnInit} from '@angular/core';
import {recoverPassForm} from '../../../Assets/angular/assets/data/forms/recover_pass';
import {ClientService} from '../../services/client.service';

@Component({
    selector: 'app-forgot-password-form',
    templateUrl: './forgot-password-form.component.html',
    styleUrls: ['./forgot-password-form.component.scss']
})
export class ForgotPasswordFormComponent implements OnInit {

    recoverPassForm: Array<object>;
    textMessage: string;
    modalId: string;

    constructor(public clientService: ClientService) {
        this.recoverPassForm = recoverPassForm;
    }

    ngOnInit(): void {
    }

}
